<template>
    <i v-if="value" class="bi-check-lg"/>
</template>

<script>
export default {
    name: "TableCellTypePassword",
    props: {
        value: String,
    }
}
</script>

<style scoped>

</style>